import React, { Fragment, useEffect, useRef, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";

const UseOtp = ({
  title,
  field,
  register,
  setValue,
  watch,
  error,
  length = 6,
  pattern = "",
}) => {
  const [otp, setOtp] = useState(
    new Array(
      pattern.length > length && pattern.includes("-") ? pattern.length : length
    ).fill("")
  );
  const [finalLength, setFinalLength] = useState(length);
  const [lastKeyPressed, setLastKeyPressed] = useState("");
  const inputsRef = useRef(new Array(length).fill(React.createRef()));

  useEffect(() => {
    if (pattern.length > length && pattern.includes("-")) {
      setFinalLength(pattern.length);
    } else {
      setFinalLength(length);
    }
  }, [pattern, length]);

  useEffect(() => {
    register(field);
  }, [field, register]);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false; // If not a number, don't process

    // Update OTP array
    const newOtp = [
      ...otp.map((d, idx) =>
        idx === index ? element.value : pattern?.[idx] === "-" ? "-" : d
      ),
    ];
    if (newOtp.join("") === "-") {
      setOtp(
        new Array(
          pattern.length > length && pattern.includes("-")
            ? pattern.length
            : length
        ).fill("")
      );
      setValue(field, "");
    } else {
      setOtp([...newOtp]);
      setValue(field, newOtp.join(""));
    }

    if (
      element?.nextSibling?.innerHTML === "-" &&
      lastKeyPressed !== "Backspace"
    ) {
      // newOtp.splice(index + 1, 0, "-");
      setOtp([...newOtp]);
      setValue(field, newOtp.join(""));
      element.nextSibling?.nextSibling?.focus();
    } else if (
      element?.previousSibling?.innerHTML === "-" &&
      lastKeyPressed === "Backspace"
    ) {
      // newOtp.splice(index - 1, 1);
      setOtp([...newOtp]);
      setValue(field, newOtp.join(""));

      element.previousSibling?.previousSibling?.focus();
    }
    // Focus next input on value entry, previous if empty (backspace/delete)
    if (element.value !== "") {
      // Move to next input if available
      if (element.nextSibling) {
        element.nextSibling.focus();
      }
    } else if (element.previousSibling) {
      // Move to previous input on backspace/delete if available
      element.previousSibling.focus();
    }
  };

  //   useEffect(() => {
  //     // Automatically focus the first input on component mount
  //     inputsRef.current[0].focus();
  //   }, []);

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text/plain")
      .slice(0, length)
      .split("");
    if (pastedData?.length === length) {
      setOtp([...pastedData]);
      setValue(field, pastedData.join(""));
      inputsRef.current[length - 1].focus();
    }
  };

  return (
    <>
      <label>{title}</label>
      <InputGroup className=" mt-5">
        {Array.from({ length: finalLength }, (_, index) => (
          <Fragment key={index}>
            {pattern.length > 0 && pattern[index] === "-" ? (
              <span className="px-4 align-self-center">-</span>
            ) : (
              <Form.Control
                type="text"
                maxLength="1"
                style={{
                  width: "3rem",
                  textAlign: "center",
                  borderRadius: "0.25rem",
                  flex: "none",
                }}
                value={otp[index]}
                onChange={(e) => handleChange(e.target, index)}
                onKeyDown={(e) => {
                  setLastKeyPressed(e.key);
                  // When the user presses backspace and the input is empty, focus the previous input
                  if (e.key === "Backspace" && !otp[index]) {
                    const prevInput = inputsRef.current[index - 1];
                    if (prevInput?.current === null) {
                      const prevInput1 = inputsRef.current[index - 2];
                      if (prevInput1) {
                        prevInput1.focus();
                      }
                    } else if (prevInput) {
                      prevInput.focus();
                    }
                  }
                }}
                onPaste={handlePaste}
                ref={(ref) => (inputsRef.current[index] = ref)}
                className="inputStyle form-control input-lg p-5"
              />
            )}
          </Fragment>
        ))}
        {error ? <div className="invalid-feedback d-block">{error}</div> : null}
      </InputGroup>
    </>
  );
};

export default UseOtp;
